<template>
<div class="bind">
	<div class="van-nav-bar van-hairline--bottom">
		<div class="van-nav-bar__content">
			<div class="van-nav-bar__left van-haptics-feedback"  @click="back()">
				<i class="van-badge__wrapper van-icon van-icon-arrow-left van-nav-bar__arrow" ></i>
			</div>
			<div class="van-nav-bar__title van-ellipsis">
				{{$t('withdrawAccountRegister')}}
			</div>
			</div>
	</div>
	<van-cell-group>
		<van-field v-model="bankName" :label="$t('bankName')" type="text" :placeholder="$t('enterBankName')" />
		<van-field v-model="branchName" :label="$t('branchName')" type="text" :placeholder="$t('enterBranchName')" />
		<van-field v-model="branchNumber" :label="$t('branchNumber')" type="text" :placeholder="$t('enterBranchNumber')" />
		<van-field v-model="accountType" :label="$t('accountType')" type="text" :placeholder="$t('enterAccountType')" />
		<van-field v-model="accountNumber" :label="$t('accountNumber')" type="text" :placeholder="$t('enterAccountNumber')" />
		<van-field v-model="katakana" :label="$t('katakana')" type="text" :placeholder="$t('enterKatakana')" />
	</van-cell-group>
	<div class="btn">
		<a @click="bindCard()">
			{{$t('common.addbank')}}
		</a>
	</div>
</div>
</template>

<script>
export default {
  data() {
    return {
      userInfo:{},
      is_bind: false,
      bankName:"",      // 銀行名称
      branchName:"",    // 支店名称
      branchNumber:"",  // 支店番号
      accountType:"",   // 取引種類
      accountNumber:"", // 口座番号
      katakana:"",      // カタカナ
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    bindCard(){
      if(this.bankName === "" || this.bankName === null || this.bankName === undefined){
        this.$toast(this.$t('enterBankName'));
        return false;
      }
      if(this.branchName === "" || this.branchName === null || this.branchName === undefined){
        this.$toast(this.$t('enterBranchName'));
        return false;
      }
      if(this.branchNumber === "" || this.branchNumber === null || this.branchNumber === undefined){
        this.$toast(this.$t('enterBranchNumber'));
        return false;
      }
      if(this.accountType === "" || this.accountType === null || this.accountType === undefined){
        this.$toast(this.$t('enterAccountType'));
        return false;
      }
      if(this.accountNumber === "" || this.accountNumber === null || this.accountNumber === undefined){
        this.$toast(this.$t('enterAccountNumber'));
        return false;
      }
      if(this.katakana === "" || this.katakana === null || this.katakana === undefined){
        this.$toast(this.$t('enterKatakana'));
        return false;
      }
      this.$http({
        method: 'post',
        data:{
          bank_name: this.bankName,
          branch_name: this.branchName,
          branch_number: this.branchNumber,
          account_type: this.accountType,
          account_number: this.accountNumber,
          katakana: this.katakana
        },
        url: 'user_set_bank'
      }).then(res=>{
        if(res.code === 200){
          this.$router.push({path:'/Mine'})
          this.$toast(res.msg);
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          this.name = res.data.name;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getUserBankInfo(){
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res=>{
        if(res.code === 200){
          if(res.data.is_bank){
            this.is_bind = true;
            this.$router.replace({path:'/Withdraw'});
          }else {
            this.is_bind = false;
          }
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
      this.getUserBankInfo();
    }
  }
};
</script>

<style lang='less' scoped>


:export {
    gbcolor: linear-gradient(30deg,#7d76ef,#d63f8c)
}
.van-nav-bar {
    z-index: 999;
	position: relative;
    background: url(/img/header.svg) no-repeat 50%/100%;
}
.van-nav-bar__content{
	height:3rem;
}

.bind {
    width: 100%;
    height: 100%;
    background: #f0f0f0
}

.bind .van-field__control::-webkit-input-placeholder {
    text-overflow: ellipsis;
    white-space: normal;
    overflow: hidden
}

.bind .van-field__control::-moz-placeholder {
    text-overflow: ellipsis;
    white-space: normal;
    overflow: hidden
}

.bind .van-field__control:-ms-input-placeholder {
    text-overflow: ellipsis;
    white-space: normal;
    overflow: hidden
}

.bind .btn {
    width: 100%;
    padding: 10%;
    display: flex;
    justify-content: center;
    align-items: center
}

.bind .btn a {
    width: 100%;
    background: linear-gradient(90deg,#f560cd,#4f2b8a);
    color: #fff;
    padding: .66667rem 0;
    border-radius: .33333rem
}

.bind .bank {
    width: 90%;
    height: 10rem;
    background: #705b65;
    border-radius: .66667rem;
    margin: 1rem auto;
    text-align: left;
    padding: 5%;
    position: relative;
    overflow: hidden
}

.bind .bank p {
    color: #ede7e7;
    padding: .13333rem 0;
    position: relative;
    z-index: 9
}

.bind .bank h1 {
    color: #fff;
    padding: .33333rem 0;
    position: relative;
    z-index: 9
}

.bind .bank span {
    position: absolute;
    right: .66667rem;
    bottom: .66667rem;
    color: #dfbb9e;
    z-index: 9
}

.bind .bank i {
    position: absolute;
    right: -3.33333rem;
    top: 0;
    color: #877f7e;
    font-size: 10rem;
    opacity: .4
}

.van-cell {
    position: relative;
    display: flex;
    box-sizing: border-box;
    width: 100%;
    padding: 0.5rem 0.6rem;
    overflow: hidden;
    color: #323233;
    font-size: 1rem;
    line-height: 2rem;
    background: #fff;
}

.van-cell__value {
    justify-content: space-between;
    align-items: center;
    display: flex
}

.van-field__body {
    width: 100%
}

.van-dropdown-menu__bar {
    height: auto;
    box-shadow: none
}

.van-dropdown-menu__item {
    justify-content: flex-start
}

.bind .van-cell__value .van-dropdown-menu__title {
    padding-left: 0
}
.bind .van-field .van-field__value{
	border:0;
}
.van-dropdown-menu__title {
    font-size: 1rem;
    line-height: 2rem;
}
</style>
